<template>
	<div class="o-container o-container--thin">
		<global-message :value="data.message" />
	</div>
</template>

<script>
	import GlobalMessage from '../messages/GlobalMessage.vue';

	export default {
		components: {
			GlobalMessage
		},
		props: ['message'],
		data() {
			return {
				data: {
					message: 'Something went wrong.'
				}
			};
		},
		created() {
			this.validateProps();
		},
		methods: {
			validateProps() {
				if (this.message) {
					this.data.message = this.message;
				}
			}
		}
	};
</script>

<style lang="scss" scoped>

</style>